import { render } from "./TheKnFooter.vue?vue&type=template&id=38958b70&scoped=true&ts=true"
import script from "./TheKnFooter.vue?vue&type=script&lang=ts"
export * from "./TheKnFooter.vue?vue&type=script&lang=ts"

import "./TheKnFooter.vue?vue&type=style&index=0&id=38958b70&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38958b70"]])

export default __exports__